<template>
  <div class="card-panel">
    <div class="emerald large-font">
      <i class="fas fa-receipt"></i> Receipt
    </div>

    <div class="row">
      <div class="col s12">
        <p class="grey-text">
          A system-generated receipt will be automatically included. 
          You may optionally attach custom invoices for transaction-specific details.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <input v-model="contact" placeholder="Phone / email">
      </div>
    </div>

    <!-- Existing Custom Invoices -->
    <div v-if="existingInvoices.length > 0" class="row">
      <div class="col s12">
        <h6>Sent Invoices:</h6>
        <div v-for="invoice in existingInvoices" :key="invoice.id" class="invoice-item">
          <label>
            <input type="checkbox" 
                   :value="invoice.id" 
                   v-model="selectedInvoiceIds" 
                   class="filled-in" />
            <span>{{ invoice.filename }} ({{ formatFileSize(invoice.byte_size) }})</span>
          </label>
        </div>
      </div>
    </div>

    <!-- New Invoice Upload -->
    <div class="row">
      <div class="col s12">
        <input type="file" 
               @change="handleFileUpload" 
               accept=".pdf,.jpg,.jpeg,.png,.gif"
               multiple
               ref="fileInput"
               style="display: none;">
        <div>
          <button type="button" class="btn outlined-btn left" @click="$refs.fileInput.click()">
            <i class="fas fa-file-upload"></i> Add Invoice
          </button>
          <br><br>
          <small class="grey-text left">Click (optionally) to select PDF/Image files (max 10MB each)</small>
        </div>
        <div v-if="fileError" class="red-text">{{ fileError }}</div>
      </div>
    </div>

    <!-- New Files Preview -->
    <div v-if="selectedFiles.length > 0" class="row">
      <div class="col s12">
        <div class="close-lines">
          <div class="bold-font large-font grey-text text-darken-2">Files to Upload:</div>
          <small class="grey-text">These files will be automatically included in the receipt.</small>
        </div>
        <div class="mt-10">
          <div v-for="(file, index) in selectedFiles" :key="index" class="chip">
            {{ file.name }} ({{ formatFileSize(file.size) }})
            <i class="fas fa-times" @click="removeFile(index)"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <button class='btn btn-large waves-effect right'
                @click='send' 
                :disabled="disabled || !contact">
          <i class="far fa-paper-plane"></i> Send Receipt
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["transactionId"],
  data() {
    return {
      contact: null,
      disabled: false,
      selectedFiles: [],
      selectedInvoiceIds: [],
      existingInvoices: [],
      fileError: null
    }
  },
  
  mounted() {
    this.loadExistingInvoices();
  },
  
  computed: {
    newFilesSelected() {
      return this.selectedFiles.length > 0;
    }
  },
  
  methods: {
    loadExistingInvoices() {
      this.$http.get(`/api/v1/app/merchant/transactions/${this.transactionId}/invoices`).then(response => {
        this.existingInvoices = response.body.invoices || [];
      }, error => {
        console.error('Failed to load existing invoices:', error);
      });
    },

    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      this.fileError = null;
      
      for (const file of files) {
        // Validate file size (10MB)
        if (file.size > 10 * 1024 * 1024) {
          this.fileError = `File ${file.name} is too large (max 10MB)`;
          return;
        }

        // Validate file type
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
          this.fileError = `File ${file.name} is not a supported type (PDF/Image only)`;
          return;
        }
      }
      
      this.selectedFiles = [...this.selectedFiles, ...files];
    },

    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    send() {
      this.disabled = true;
      
      const formData = new FormData();
      formData.append('phone', this.contact);
      formData.append('transaction_id', this.transactionId);
      
      // Add new files
      this.selectedFiles.forEach(file => {
        formData.append('custom_invoices[]', file);
      });
      
      // Add selected existing invoice IDs
      this.selectedInvoiceIds.forEach(id => {
        formData.append('selected_invoice_ids[]', id);
      });

      this.$http.post('/api/v1/app/merchant/blind_transaction/phones', formData).then(response => {
        this.notifySuccess(response.body.message);
        this.selectedFiles = [];
        this.selectedInvoiceIds = [];
        this.$refs.fileInput.value = '';
        this.loadExistingInvoices(); // Refresh list
      }, error => {
        this.errorHandler(error);
      }).finally(() => {
        this.disabled = false;
      });
    }
  }
}
</script>
<style scoped>
.invoice-item {
  margin: 10px 0;
}
.chip {
  margin: 5px;
}
.chip i {
  cursor: pointer;
  margin-left: 5px;
}
</style>
